module.exports = __webpack_public_path__ + "static/media/tax-rероrtіng.199f6321.svg";